import { OctoCart } from '@repo/types';

interface IOctoClearEvent {
    type: 'CLEAR';
}

interface IOctoSetCleanEvent {
    type: 'SET_CLEAN';
}

interface IOctoSetDirtyEvent {
    type: 'SET_DIRTY';
}

interface IOctoInitializeEvent {
    type: 'INITIALIZE';
    data: string;
}

export type OctoCartEvents =
    | IOctoClearEvent
    | IOctoInitializeEvent
    | IOctoSetCleanEvent
    | IOctoSetDirtyEvent;

export function reduceOctoCartState(state: OctoCart, action: OctoCartEvents): OctoCart {
    switch (action.type) {
        case 'CLEAR':
            return {
                isDirty: false,
            };
        case 'INITIALIZE':
            return { id: action.data, isDirty: true };
        case 'SET_CLEAN':
            return { ...state, isDirty: false };
        case 'SET_DIRTY':
            return { ...state, isDirty: true };
        default:
            return state;
    }
}

export function initializeOctoCartEvent(cartId: string): IOctoInitializeEvent {
    return {
        type: 'INITIALIZE',
        data: cartId,
    };
}

export function clearOctoCartEvent(): IOctoClearEvent {
    return {
        type: 'CLEAR',
    };
}

export function setOctoCartCleanEvent(): IOctoSetCleanEvent {
    return {
        type: 'SET_CLEAN',
    };
}

export function setOctoCartDirtyEvent(): IOctoSetDirtyEvent {
    return {
        type: 'SET_DIRTY',
    };
}

export const selectHasExistingOctoCart = (state: OctoCart) => !!state.id;
export const selectOctoCartId = (state: OctoCart) => state.id;
